import { SubState } from '../state';
import { AppState } from '../state.module';
import { StepGuard } from '../../core/model/step-guard';

export class FinancingState implements SubState {

  constructor(
    private _parent: AppState = null,
    private _step: StepGuard = new StepGuard(),
    private _saleId: string = null,
    private _customerType: string = null,
    private _totalSale: number = null
  ) { }

  get parent(): AppState {
    return this._parent;
  }

  get step(): StepGuard {
    return this._step;
  }

  get saleId(): string {
    return this._saleId;
  }

  get customerType(): string {
    return this._customerType;
  }

  get totalSale(): number {
    return this._totalSale;
  }

  withParent(parent: AppState): FinancingState {
    return new FinancingState(
      parent,
      this._step,
      this._saleId,
      this.customerType,
      this.totalSale
    );
  }

  addCurrentWizzardStep(step: StepGuard): AppState {
    return this._parent.withFinancing(this.recreate(
      step,
      this._saleId,
      this.customerType,
      this.totalSale
    ));
  }

  addSaleId(saleId: string): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      saleId,
      this.customerType,
      this.totalSale
    ));
  }

  addInitInfo(brand: string, model: string, purchasePhoneAmount: number): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      this.customerType,
      this.totalSale
    ));
  }

  addPhoneInfo(imei: string, imgReceiptUrl: string, note: string, purchaseDate: string): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      this.customerType,
      this.totalSale
    ));
  }

  addFinancingCustomerType(customerType: string): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      customerType,
      this.totalSale
    ));
  }

  addFinancingCustomerId(customerId: string): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      customerId,
      this.totalSale
    ));
  }

  AddFinancingPaymentId(paymentId: string): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      this.customerType,
      this.totalSale
    ));
  }

  AddFinancingTotalSale(totalSale: number): AppState {
    return this._parent.withFinancing(this.recreate(
      this._step,
      this._saleId,
      this.customerType,
      totalSale
    ));
  }

  private recreate(
    step: StepGuard,
    saleId: string,
    customerType: string,
    totalSale: number,
  ): FinancingState {
    return new FinancingState(
      null,
      step,
      saleId,
      customerType,
      totalSale
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/state/financing/financing-state.ts